import { render, staticRenderFns } from "./AnalysesOtherCategoriesDrawer.vue?vue&type=template&id=d4e9457e&"
import script from "./AnalysesOtherCategoriesDrawer.vue?vue&type=script&setup=true&lang=ts&"
export * from "./AnalysesOtherCategoriesDrawer.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d4e9457e')) {
      api.createRecord('d4e9457e', component.options)
    } else {
      api.reload('d4e9457e', component.options)
    }
    module.hot.accept("./AnalysesOtherCategoriesDrawer.vue?vue&type=template&id=d4e9457e&", function () {
      api.rerender('d4e9457e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/[town-translit]/diagnostika/analiz/components/AnalysesOtherCategoriesDrawer.vue"
export default component.exports